import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import MachinesPage from './pages/MachinesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-white text-gray-800 font-sans antialiased">
        <Header />
        <main className="flex-1">
          <Routes>
            {/* Home */}
            <Route path="/" element={<HomePage />} />

            {/* Ydelser Overview */}
            <Route path="/ydelser" element={<ServicesPage />} />
            <Route path="/ydelser/" element={<ServicesPage />} />

            {/* Service Details */}
            <Route path="/vognmandskorsel-2" element={<ServiceDetailPage customSlug="vognmandskorsel-2" />} />
            <Route path="/vognmandskorsel-2/" element={<ServiceDetailPage customSlug="vognmandskorsel-2" />} />

            <Route path="/kranarbejde-2" element={<ServiceDetailPage customSlug="kranarbejde-2" />} />
            <Route path="/kranarbejde-2/" element={<ServiceDetailPage customSlug="kranarbejde-2" />} />

            <Route path="/grapning-af-slam-og-flydelag" element={<ServiceDetailPage customSlug="grapning-af-slam-og-flydelag" />} />
            <Route path="/grapning-af-slam-og-flydelag/" element={<ServiceDetailPage customSlug="grapning-af-slam-og-flydelag" />} />

            <Route path="/containerudlejning-service" element={<ServiceDetailPage customSlug="containerudlejning-service" />} />
            <Route path="/containerudlejning-service/" element={<ServiceDetailPage customSlug="containerudlejning-service" />} />

            <Route path="/kornkorsel" element={<ServiceDetailPage customSlug="kornkorsel" />} />
            <Route path="/kornkorsel/" element={<ServiceDetailPage customSlug="kornkorsel" />} />

            <Route path="/entreprenor-nedbrydningsopgaver" element={<ServiceDetailPage customSlug="entreprenor-nedbrydningsopgaver" />} />
            <Route path="/entreprenor-nedbrydningsopgaver/" element={<ServiceDetailPage customSlug="entreprenor-nedbrydningsopgaver" />} />

            <Route path="/modtagelse-af-byggeaffald" element={<ServiceDetailPage customSlug="modtagelse-af-byggeaffald" />} />
            <Route path="/modtagelse-af-byggeaffald/" element={<ServiceDetailPage customSlug="modtagelse-af-byggeaffald" />} />

            <Route path="/grus-udlaegnings-korsel" element={<ServiceDetailPage customSlug="grus-udlaegnings-korsel" />} />
            <Route path="/grus-udlaegnings-korsel/" element={<ServiceDetailPage customSlug="grus-udlaegnings-korsel" />} />

            <Route path="/halm-korsel" element={<ServiceDetailPage customSlug="halm-korsel" />} />
            <Route path="/halm-korsel/" element={<ServiceDetailPage customSlug="halm-korsel" />} />

            <Route path="/stammetraes-korsel" element={<ServiceDetailPage customSlug="stammetraes-korsel" />} />
            <Route path="/stammetraes-korsel/" element={<ServiceDetailPage customSlug="stammetraes-korsel" />} />

            <Route path="/jernplade-leje" element={<ServiceDetailPage customSlug="jernplade-leje" />} />
            <Route path="/jernplade-leje/" element={<ServiceDetailPage customSlug="jernplade-leje" />} />

            <Route path="/sorterings-anlaeg" element={<ServiceDetailPage customSlug="sorterings-anlaeg" />} />
            <Route path="/sorterings-anlaeg/" element={<ServiceDetailPage customSlug="sorterings-anlaeg" />} />

            <Route path="/gylletrailer-39-m3" element={<ServiceDetailPage customSlug="gylletrailer-39-m3" />} />
            <Route path="/gylletrailer-39-m3/" element={<ServiceDetailPage customSlug="gylletrailer-39-m3" />} />

            <Route path="/buffer-kasse-100-m3" element={<ServiceDetailPage customSlug="buffer-kasse-100-m3" />} />
            <Route path="/buffer-kasse-100-m3/" element={<ServiceDetailPage customSlug="buffer-kasse-100-m3" />} />

            <Route path="/stobningsarbejde" element={<ServiceDetailPage customSlug="stobningsarbejde" />} />
            <Route path="/stobningsarbejde/" element={<ServiceDetailPage customSlug="stobningsarbejde" />} />

            <Route path="/anlaegsopgaver" element={<ServiceDetailPage customSlug="anlaegsopgaver" />} />
            <Route path="/anlaegsopgaver/" element={<ServiceDetailPage customSlug="anlaegsopgaver" />} />

            <Route path="/kloak-og-jordarbejde" element={<ServiceDetailPage customSlug="kloak-og-jordarbejde" />} />
            <Route path="/kloak-og-jordarbejde/" element={<ServiceDetailPage customSlug="kloak-og-jordarbejde" />} />

            {/* Other pages */}
            <Route path="/maskiner" element={<MachinesPage />} />
            <Route path="/maskiner/" element={<MachinesPage />} />

            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/om-os/" element={<AboutPage />} />

            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/kontakt/" element={<ContactPage />} />

            {/* 403 & 404 */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
